/* News Client barrel export */

import { NewsClientMocked } from './newsClientMocked';

// Re-export types
export * from './newsTypes';

// News has no real backend yet (the /api/news Ocelot route exists but the downstream isn't
// implemented — 500s in practice) — always use the in-code mocked client. Some pages
// instantiate their own client instance directly (`new NewsClient()`); keep that name pointing
// at the mocked implementation.
export { NewsClientMocked };
export { NewsClientMocked as NewsClient };

/**
 * News client singleton instance.
 */
export const newsClient = new NewsClientMocked();

/**
 * @deprecated Use `newsClient` directly instead.
 */
export function getNewsClient(): NewsClientMocked {
  return newsClient;
}
